<template>
  <div class="faqContent">
    <Header
      :header="header"
      pageIcon="help_outline"
      :content="content"

      :sitecode="school.site_code"
      :showInfo="false"
    />
    <v-row justify="space-between">
      <v-col cols="12"
      >
        <v-tabs class="contentSpacer"
          slider-color="accent"
          color="accent"
          background-color="transparent"
        >
          <v-tab @click="showFaq">FAQ</v-tab>
          <v-tab @click="showSources">DATA SOURCES</v-tab>
          <v-tab @click="showGlossary">DATA GLOSSARY</v-tab>
          <v-tab @click="showGuide">USER GUIDES</v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <v-container class="contentSpacer" fluid>
      <v-row>
        <v-col cols="12"
          sm="12"
        >
          <FAQ v-if="showContent == 'faq'"/>
          <SOURCES v-if="showContent == 'sources'"/>
          <GLOSSARY v-if="showContent == 'glossary'"/>
          <USERGUIDES v-if="showContent == 'guidesusage'"/>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import FAQ from "../simpleComponents/FAQ";
  import USERGUIDES from '../simpleComponents/Guide';
  import GLOSSARY from '../simpleComponents/Glossary';
  import Header from '../simpleComponents/Header';
  import SOURCES from '../simpleComponents/Sources';
  import {mapGetters} from "vuex";
  export default {
    name: "FAQDashboard",
    components: {
      Header,
      FAQ,
      GLOSSARY,
      SOURCES,
      USERGUIDES
    },
    methods:{
      showFaq:function(){
        this.showContent = 'faq';
      },
      showGlossary:function(){
        this.showContent = 'glossary';
      },
      showSources:function(){
        this.showContent = 'sources';
      },
      showGuide:function(){
        this.showContent = 'guidesusage';
      }
    },
    data: () => ({
      header: "Help & Support",
      content: "Help & Support",
      showContent:"faq",
    }),
    computed: {
      ...mapGetters([
        'school',
      ]),
    }
  };
</script>

<style scoped>
.container .container--fluid{
  padding-bottom:0px !important;
}
.customGroup{
  margin-left:92px;
}
.v-tab{
 font-weight: normal;
 color:#041E42 !important;
}
.v-tab--active{
  font-weight: bold;
  
}
</style>
